// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file dump/inventory_dump.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { DumpItems } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.PharmacyRawDumpRequest
 */
export class PharmacyRawDumpRequest extends Message<PharmacyRawDumpRequest> {
  /**
   * @generated from field: string pharmacy_code = 1;
   */
  pharmacyCode = "";

  /**
   * @generated from field: repeated com.neulink.pharmacy.DumpItems items = 2;
   */
  items: DumpItems[] = [];

  /**
   * @generated from field: string stock_point_id = 3;
   */
  stockPointId = "";

  constructor(data?: PartialMessage<PharmacyRawDumpRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PharmacyRawDumpRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pharmacy_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "items", kind: "message", T: DumpItems, repeated: true },
    { no: 3, name: "stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PharmacyRawDumpRequest {
    return new PharmacyRawDumpRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PharmacyRawDumpRequest {
    return new PharmacyRawDumpRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PharmacyRawDumpRequest {
    return new PharmacyRawDumpRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PharmacyRawDumpRequest | PlainMessage<PharmacyRawDumpRequest> | undefined, b: PharmacyRawDumpRequest | PlainMessage<PharmacyRawDumpRequest> | undefined): boolean {
    return proto3.util.equals(PharmacyRawDumpRequest, a, b);
  }
}

